import React, { Fragment } from 'react';

import { ObjectFieldTemplateProps } from '@rjsf/core';
import { Segment, Accordion, Icon } from 'semantic-ui-react'
import { AccordionObjectFieldProvider, useAccordionObjectFieldContext } from './AccordionObjectFieldContext';
import { AccordionItem } from './AccordionItem';
import { RenderAccordion } from './RenderAccordion';
import { calculateEvaluationStatus } from '../../../../utils/calculateEvaluationStatics';
import { EEvaluationStatus } from '../../../../interfaces/IEvaluation';
import "./_AccordionObjectField.less";
import "./_AnimatedAccordion.less";
import { useSchemaTranslation } from '../../../../../sg-schema/useSchemaTranslation';
import { getUiOptions } from '../../../../../sg-schema/schema.helpers';


export const makeAccordionTitleId = (accordionId: string) => `${accordionId}-accordion-object-title`


const AccordionItemObjectField = (props: ObjectFieldTemplateProps) => {
  const {
    title,
    properties,
    uiSchema,
    idSchema,
    formContext = {},
  } = props;

  const { propertyWrapper } = formContext
  const { segmentProps } = getUiOptions(uiSchema) || {}

  const isRoot = idSchema.$id === "root"
  const PropertyWrapper = propertyWrapper || isRoot ? Fragment : Segment;

  const observationForm = uiSchema["ui:observationFormReference"];
  const { t } = useSchemaTranslation();

  const context = useAccordionObjectFieldContext();
  const accordionKey = idSchema.$id

  const toggleTopLevelAccordion = () => {
    if (context?.toggleItem) {
      context.toggleItem(accordionKey);
    }
  };

  const renderElement = (element: any, index: number) => {

    if (!element.content.props.uiSchema["ui:observationFormReference"]) {
      element.content.props.uiSchema["ui:observationFormReference"] = observationForm;
    }

    const props = element.content.props
    const accordionKey = props.idSchema.$id;
    const descirption = props.description || (props.uiSchema && props.uiSchema["ui:description"]) || props.schema.description;

    const accordion = accordionKey !== "root_context" && (typeof props.uiSchema["ui:accordion"] === "undefined" || props.uiSchema["ui:accordion"] !== false)

    const title = props.schema.title || props.uiSchema["ui:title"] || props.title;

    if (accordion) {
      const status = props.formData ? calculateEvaluationStatus(props.formData) : undefined;

      const color = status === EEvaluationStatus.Okay ? "green" : status === EEvaluationStatus.NotOkay ? "red" : status === EEvaluationStatus.Uknown ? "grey" : ""


      return (
        <RenderAccordion
          key={index}
          render={({ toggleItem, active }) => (
            <AccordionItem
              hasError={Object.keys(props.errorSchema).length >= 1}
              title={(
                <Fragment>
                  {t(title)}
                  {color ? <Icon style={{ float: "right" }} name="circle" color={color} /> : undefined}
                </Fragment>
              )}
              description={descirption ? t(descirption) : props.description}
              active={accordionKey === active}
              onToggle={() => toggleItem(accordionKey)}
              key={index}
              children={element.content}
            />
          )}
        />
      )
    };

    return (
      <Fragment key={index}>
        {element.content}
      </Fragment>
    )
  };



  const erroredElement = properties.find((element: any) => Object.keys(element.content.props.errorSchema).length >= 1)
  const hasErrors = Boolean(erroredElement);


  return (
    <Accordion
      className={"AccordionObjectField-accordion animated-accordion"}
      styled
    >
      <AccordionItem
        title={t(uiSchema['ui:title'] || title)}
        description={t(props.description)}
        active={accordionKey === context?.active}
        onToggle={toggleTopLevelAccordion}
        hasError={hasErrors}
      >

        <Accordion className="AccordionObjectField-accordion animated-accordion" styled>
          <AccordionObjectFieldProvider>



            <PropertyWrapper {...segmentProps}>
              <div id={makeAccordionTitleId(accordionKey)} style={{ display: "none", opacity: 0 }}>{uiSchema['ui:title'] || title} </div>
              {properties.map(renderElement)}
            </PropertyWrapper>

          </AccordionObjectFieldProvider>
        </Accordion>
      </AccordionItem>
    </Accordion>
  );
};

export default AccordionItemObjectField;
